import { render, staticRenderFns } from "./list.vue?vue&type=template&id=4d3fccf2"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d3fccf2')) {
      api.createRecord('4d3fccf2', component.options)
    } else {
      api.reload('4d3fccf2', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=4d3fccf2", function () {
      api.rerender('4d3fccf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parts/list.vue"
export default component.exports